import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppHandlingContext } from '../contexts/app-handling.context';
import { url } from '../util/utils';
export function useNavigation() {
    const navigateTo = useNavigate();
    const { search, pathname } = useLocation();
    const { redirectPath, setRedirectPath } = useAppHandlingContext();
    function navigate(to, options) {
        if (options === null || options === void 0 ? void 0 : options.setRedirect)
            setRedirectPath(pathname);
        switch (typeof to) {
            case 'number':
                return navigateTo(to);
            case 'string':
                return navigateTo(url(to, new URLSearchParams(search)), options);
            default:
                const params = addParams(new URLSearchParams(to.search), options === null || options === void 0 ? void 0 : options.clearParams);
                to.search = `?${params}`;
                return navigateTo(to, options);
        }
    }
    function goBack() {
        setRedirectPath(undefined);
        navigate(redirectPath !== null && redirectPath !== void 0 ? redirectPath : '/');
    }
    function setParams(newParams) {
        const params = addParams(newParams);
        return navigateTo(url(pathname, params));
    }
    function addParams(newParams, clearParams) {
        const params = new URLSearchParams(search);
        newParams.forEach((val, key) => params.set(key, val));
        clearParams === null || clearParams === void 0 ? void 0 : clearParams.forEach((s) => params.delete(s));
        return params;
    }
    function clearParams(params) {
        navigate({ pathname }, { replace: true, clearParams: params });
    }
    return useMemo(() => ({ navigate, goBack, setParams, clearParams }), [navigateTo, search, pathname, redirectPath]);
}
